import React from 'react';
import { useTranslation } from 'react-i18next';
import { PANEL_VARIANTS } from './constants';

import pampImage from './assets/graphics/pamp_where_to_buy.jpg';
import royalImage from './assets/graphics/royalmint.jpg';

/**
 * Props pro PanelContent komponentu
 */
interface PanelContentProps {
  /** Typ panelu - určuje jaký obsah se zobrazí */
  type: typeof PANEL_VARIANTS[keyof typeof PANEL_VARIANTS];
}

/**
 * Komponenta pro zobrazení obsahu různých panelů (PAMP, Royal Mint, Lloyd's)
 */
export default function PanelContent({ type }: PanelContentProps): React.ReactElement | null {
  const { t } = useTranslation('common');

  if (type === PANEL_VARIANTS.PAMP) {
    return (
      <div className='panel-content'>
        <p>{t('panels.pamp.content')}</p>
        <a href='https://www.pamp.com/where-to-buy/' target='_blank' rel="noopener noreferrer"><img alt='PampImage' src={pampImage} /></a>
      </div>
    );
  }

  if (type === PANEL_VARIANTS.ROYAL_MINT) {
    return (
      <div className='panel-content'>
        <p>{t('panels.royalMint.content')}</p>
        <a href='https://www.royalmint.com/corporate/official-bullion-distributors' target='_blank' rel="noopener noreferrer"><img alt='RoyalMint' src={royalImage} /></a>
      </div>
    );
  }

  if (type === PANEL_VARIANTS.LLOYDS_INSURANCE) {
    return (
      <div className='panel-content'>
        <p>{t('panels.lloyds.content')}</p>
      </div>
    );
  }

  return null;
}
